import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippy.js/react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { IconInfo, IconLink } from 'svgIcons/MotionPortalIcons';
import { onlineHelpLinks } from 'helpers/constants';

import './style.scss';
import { getEnvironmentStageSelector } from 'helpers/selectors';

const InfoButtonWithOnlineHelp = ({ placement = 'bottom', trigger = 'manual', maxWidth = '400px', infoText, withoutLink, ...props }) => {

    const { i18n } = useTranslation();
    const environment = useSelector(getEnvironmentStageSelector);
    const languageCode = i18n.language;
    const [isVisible, setIsVisible] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const close = () => setIsVisible(false);
        const handleClickOutside = (e) => {
            if (!wrapperRef.current?.contains(e.target) && !e.target.closest('.info-button-with-online-help-tippy')) {
                close();
            }
        };
        window.addEventListener('scroll', close, true);
        document.addEventListener('mousedown', handleClickOutside, true);
        return () => {
            window.removeEventListener('scroll', close, true);
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, []);

    return <div ref={wrapperRef} className='info-button-with-online-help' role='tooltip' {...props}>
        <Tippy
            content={<React.Fragment>
                {infoText}
                {!withoutLink && <a className='description-link' rel='noreferrer' target='_blank' href={`${onlineHelpLinks[environment]}${languageCode}`}>
                    <IconLink width='16' height='16' viewBox='0 0 16 16' />
                </a>}
            </React.Fragment>}
            className='info-button-with-online-help-tippy'
            interactive={true}
            interactiveBorder={10}
            animation='scale'
            theme='light-border'
            trigger={trigger}
            visible={isVisible}
            hideOnClick={false}
            placement={placement}
            maxWidth={maxWidth}
            boundary='viewport'
            appendTo={document.body}
        >
            <button type='button' onClick={(e) => { e.stopPropagation(); setIsVisible(v => !v); }}>
                <IconInfo width={props.width} height={props.width} color={'black'} />
            </button>
        </Tippy>
    </div>;
};

InfoButtonWithOnlineHelp.propTypes = {
    infoText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    withoutLink: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placement: PropTypes.string,
    trigger: PropTypes.string,
    maxWidth: PropTypes.string,
};

export default InfoButtonWithOnlineHelp;

